import { ref, reactive } from 'vue'
import { getDetail, userEvent } from '@/apis/informationDetail.js'
import { getRelated } from '@/apis/special.js'
import { getReadingNums } from '@/utils'
import { getQueryString, getThemeType, getLangType } from '@/utils/tools.js'
import { Toast } from 'vant'
import { formatPublishTime } from '../utils/time'
import DOMPurify from 'dompurify'
import { purifyConfig } from '../utils/purify'

export function useArticle() {
    const id = ref('')
    const theme = ref(getThemeType())
    const infoData = ref({})
    const specialList = ref([])
    const showLoading = ref(false)
    const isSpecial = ref(false)
    const colorType = ref(1)

    // Init basic params from URL
    const initParams = (isTHSApp) => {
        id.value = getQueryString('id', true)
        const agentColor = getUserAgent('priceColorType')
        colorType.value = isTHSApp() ? 3 : (agentColor || getQueryString('colorType', true) || 1)
        isSpecial.value = getQueryString('textType', true)
    }

    const getUserAgent = (key) => {
        const arr = window.navigator.userAgent.split(' ')
        const obj = {}
        arr.forEach(item => {
            if (item.indexOf('/') > 0) {
                const _arr = item.split('/')
                obj[_arr[0]] = _arr[1]
            }
        })
        return obj[key]
    }

    const getSpecialRelated = async () => {
        const params = {
            newsId: id.value,
        }
        try {
            const { data } = await getRelated(params)
            const list = data.result ? data.result.list : []
            specialList.value = list
        } catch (e) {
            console.error(e)
        }
    }

    const getInformationDetail = async (t) => { // t is $t function
        showLoading.value = true
        const params = {
            id: id.value,
            ver: 2,
        }
        try {
            const { data } = await getDetail(params)
            showLoading.value = false
            if (!data.error) {
                const result = data.result
                result.title = DOMPurify.sanitize(result.title || '')
                result.publishText = formatPublishTime(result.publish)
                
                const processed = result.content
                    .replace(/<p>\s+/g, '<p>')
                    .replace(/isPdf=1/g, 'isPdf=1&fhzqwebview=pdf')
                    .replace(/\n/gm, "<span style='display:block'></span>")
                    .replace(/<table[^>]*>[\s\S]*?<\/table>/g, match => `<div class="hn-scroll-area">${match}</div>`)
                    .replace(
                        /<a[^>]*href=["']stockCode=([^"']+)["'][^>]*>(.*?)<\/a>/g,
                        '<span class="stock-link" data-stock-id="$1" style="color: #0569ff;">$2</span>'
                    )
                
                result.contentText = DOMPurify.sanitize(processed, result.isAI ? purifyConfig : null)
                result.readNum = getReadingNums(result.extra?.readNum)

                const tip = result.isAI ? t('disclaimer4AI') : t('disclaimer')
                result.disclaimers = DOMPurify.sanitize(tip)

                infoData.value = result
                return result
            }
        } catch (error) {
            showLoading.value = false
            Toast(t('newwork'))
        }
        return null
    }

    const setUserEvent = async () => {
        const params = {
            newsIds: [id.value],
            type: 'news',
        }
        await userEvent(params)
    }

    return {
        id,
        theme,
        infoData,
        specialList,
        showLoading,
        isSpecial,
        colorType,
        initParams,
        getSpecialRelated,
        getInformationDetail,
        setUserEvent,
        getUserAgent
    }
}
